import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import CacheKeys from '../../../cache/CacheKeys'
import CacheManager from '../../../cache/CacheManager'
import MessageUtils from '../../../util/MessageUtils'
import RestApiUtils from '../../../apiclient/moebli/RestApiUtils'
import ProjectCreateUI from './ProjectCreateUI.js'

class ProjectCreateSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      successMsg: null,
      errorList: null,
      errorCode: null,
      // project type
      projectType: '',
      projectTypeList: null,
      // project name
      projectName: '',
      projectNameError: null,
      // short code
      shortCode: '',
      shortCodeError: null,
      // template
      templateId: '',
      templateList: null,
      projectList: null,
      // project visibilities
      visibility: '',
      visibilityList: null,
      // project code
      projectCode: '',
      projectCodeError: null,
      // description
      description: '',
      descriptionError: null,
      // announcement
      announcement: '',
      announcementError: null,
      // form events
      submitted: false,
    }
  }

  render() {
    return (
      <ProjectCreateUI
        context={this.props.context}
        messageList={this.props.messageList}
        errorList={this.state.errorList}
        errorCode={this.state.errorCode}
        successMsg={this.state.successMsg}
        // project type
        projectType={this.state.projectType}
        projectTypeList={this.state.projectTypeList}
        onProjectTypeChange={(event) => {this.setState({projectType: event.target.value, templateId: '-1'})}}
        // project name
        projectName={this.state.projectName}
        onProjectNameChange={(event) => {this.setState({projectName: event.target.value})}}
        projectNameError={this.state.projectNameError}
        setProjectNameError={(error) => {this.setState({projectNameError: error})}}
        // short code
        shortCode={this.state.shortCode}
        onShortCodeChange={(event) => {this.setState({shortCode: event.target.value.toUpperCase()})}}
        shortCodeError={this.state.shortCodeError}
        setShortCodeError={(error) => {this.setState({shortCodeError: error})}}
        // template
        // when projectType=='template', "based on" is all projects+templates (projectList)
        // when projectType=='project', "based on" is only templates (projectList)
        templateId={this.state.templateId}
        templateList={this.state.templateList}
        projectList={this.state.projectList}
        onTemplateIdChange={(event) => {this.setState({templateId: event.target.value})}}
        // visibility
        visibility={this.state.visibility}
        visibilityList={this.state.visibilityList}
        onVisibilityChange={(event) => {this.setState({visibility: event.target.value})}}
        // project code
        projectCode={this.state.projectCode}
        onProjectCodeChange={(event) => {this.setState({projectCode: event.target.value})}}
        projectCodeError={this.state.projectCodeError}
        setProjectCodeError={(error) => {this.setState({projectCodeError: error})}}
        // description
        description={this.state.description}
        onDescriptionChange={(event) => {this.setState({description: event.target.value})}}
        descriptionError={this.state.descriptionError}
        setDescriptionError={(error) => {this.setState({descriptionError: error})}}
        // announcement
        announcement={this.state.announcement}
        onAnnouncementChange={(event) => {this.setState({announcement: event.target.value})}}
        announcementError={this.state.announcementError}
        setAnnouncementError={(error) => {this.setState({announcementError: error})}}
        // form events
        onSubmit={this.onSubmit}
        submitted={this.state.submitted}
        setErrorList={this.setErrorList}
      />
    )
  }

  componentDidMount() {
    let context = this.props.context
    this.getProjects(context)
    this.getProjectTypes(context)
    this.getProjectVisibilities(context)
  }

  onSubmit = () => {
    let submitted = this.state.submitted
    if (submitted)
      return

    this.setState({
      successMsg: null,
      errorList: [],
      submitted: true
    })

    RestApiUtils.post(this.props.context,
      `/api/accounts/${this.props.context.session.accountId}/projects`,
      this.onSubmitCallback, {
        projectType: this.state.projectType,
        projectName: this.state.projectName,
        shortCode: this.state.shortCode,
        templateId: this.state.templateId,
        visibility: this.state.visibility,
        projectCode: this.state.projectCode,
        description: this.state.description,
        announcement: this.state.announcement,
      }
    )
  }

  onSubmitCallback = (response) => {
    let errorList = []
    response.errorList.forEach(error => {
      errorList.push(error.message)
      switch(error.fieldName) {
        case 'projectName':
          this.setState({projectNameError: error.message})
          break;
        case 'shortCode':
          this.setState({shortCodeError: error.message})
          break;
        case 'projectCode':
          this.setState({projectCodeError: error.message})
          break;
        case 'description':
          this.setState({descriptionError: error.message})
          break;
        case 'announcement':
          this.setState({announcementError: error.message})
          break;
        default:
      }
      if (error.errorCode)
        this.setState({errorCode: error.errorCode}) // 'SubscriptionNotActive'
    })

    this.setState({
      successMsg: response.success,
      errorList: errorList,
      submitted: false
    })

    window.scrollTo({top: 0, left: 0, behavior: 'smooth'})

    let context = this.props.context
    if (this.state.errorList.length === 0) {
      CacheManager.removeObject(CacheKeys.Projects(context.session.accountId, context.session.userId))
      setTimeout(() => {
        this.props.history.push('/projects')
      }, 2000)
    }
  }

  setErrorList = (errorList) => {
    this.setState({errorList: errorList})
    if (errorList && errorList.length > 0)
      window.scrollTo({top: 0, left: 0, behavior: 'smooth'})
  }

  getProjects(context) {
    let cacheManager = new CacheManager({
      resource: `/api/accounts/${context.session.accountId}/projects`,
      cacheKey: CacheKeys.Projects(context.session.accountId, context.session.userId),
      callback: this.getProjectsCallback,
      ttlInSecs: 3600
    })
    cacheManager.getObject2(context)
  }

  getProjectsCallback = (response) => {
    if (response.errorList.length > 0) {
      this.props.history.replace('/projects')
      return
    }

    let projectList = response.projectList
      .filter(project => project.status !== 'archived' && project.roleId)
      .map(project => ({key: project.projectId, value: project.projectName}))
    let templateList = response.projectList
      .filter(project => project.status !== 'archived' && project.projectType === 'template' && project.roleId)
      .map(project => ({key: project.projectId, value: project.projectName}))

    let none = MessageUtils.getMessageValue(this.props.messageList, 'c_none')
    projectList.unshift({key: '-1', value: (this.props.messageList ? none : '----')})
    templateList.unshift({key: '-1', value: (this.props.messageList ? none : '----')})

    this.setState({
      projectType: 'project',
      projectList: projectList,
      templateList: templateList,
      templateId: templateList.length > 0 ? templateList[0].key : ''
    })
  }

  getProjectTypes(context) {
    let cacheManager = new CacheManager({
      resource: `/api/pub/project-types`,
      cacheKey: CacheKeys.ProjectTypes(),
      callback: this.getProjectTypesCallback,
      ttlInSecs: 3600
    })
    cacheManager.getObject2(context)
  }

  getProjectTypesCallback = (response) => {
    let projectTypeList = Object.keys(response.projectTypeMap)
      .map(key => ({key: key, value: response.projectTypeMap[key]}))
    this.setState({
      projectTypeList: projectTypeList,
      projectType: 'project',
    })
  }

  getProjectVisibilities(context) {
    let cacheManager = new CacheManager({
      resource: `/api/pub/project-visibilities`,
      cacheKey: CacheKeys.ProjectVisibilities(),
      callback: this.getProjectVisibilitiesCallback,
      ttlInSecs: 3600
    })
    cacheManager.getObject2(context)
  }

  getProjectVisibilitiesCallback = (response) => {
    let visibilityList = Object.keys(response.projectVisibilityMap)
      .map(key => ({key: key, value: response.projectVisibilityMap[key]}))
    this.setState({
      visibilityList: visibilityList,
      visibility: visibilityList[0].key
    })
  }

}

export default withRouter(ProjectCreateSF)
